import axios from "axios";
import { MessageBox, Message, Notification } from "element-ui";
import auth from "./auth";
import { windowRefreshToken } from "./refreshToken";
// import platInfo from "./platKey";
// import router from 'vue-router';
// import {showMsgBox,showMsg} from "./base.js"
//   let confirmState = false;
window.isReresh = false; // 用于判断是否刷新
let messageInstance = null;
let messageBoxInstance = null;
const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(options);
  return messageInstance;
};

let resetMessageBox = (msgType, msg, title) => {
  if (messageBoxInstance) {
    MessageBox.close();
    // messageBoxInstance=null;
  }
  messageBoxInstance = MessageBox[msgType](msg, title || "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    customClass: "round-msg-box",
  });
  return messageBoxInstance;
};
const service = axios.create({
  baseURL: "/api",
  timeout: 1500000,
  headers: {
    "Content-Type": "application/json; charset=UTF-8",
  },
});
service.interceptors.request.use(
  (config) => {
    // let pathname = !platInfo.platPath
    // ? "/" + process.env.VUE_APP_CODE + "/"
    // : process.env.VUE_APP_PUBLIC_PATH + "/";
    // console.log(platInfo,pathname,'platInfoplatInfoplatInfoplatInfo')
    const token = auth.getToken();
    config.headers = { ...config.headers, ...auth.configHeader() };
    if (token) {
      if (!config.otherToken) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      //请求头中自定义传租户编码
      if (config.customTenantCode) {
        config.headers["tenant-code"] = config.customTenantCode;
      }
      windowRefreshToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return Promise.resolve(response);
    }
    let errorType = response.config.errorType || "";
    const res = response.data;
    const errorMsg = response.data.msg ? response.data.msg : "";
    let msg = "";
    msg = errorMsg.length > 30 ? "系统异常" : errorMsg;
    if (res.code !== "00000" && errorType != "allMsg") {
      Message.error(msg);
    }
    return Promise.resolve(res);
  },
  (error) => {
    let code = 0;
    let msg = "";
    try {
      code = error.response.status;
      if (error.response.data && error.response.data.msg) {
        let message = error.response.data.msg;
        msg = message.length > 30 ? "系统异常" : message;
      }
    } catch (e) {
      if (error.toString().indexOf("Error: timeout") !== -1) {
        Notification.error({
          title: "网络请求超时",
          duration: 2500,
        });
        return Promise.reject(error);
      }
      if (error.toString().indexOf("Error: Network Error") !== -1) {
        Notification.error({
          title: "网络请求错误",
          duration: 2500,
        });
        return Promise.reject(error);
      }
    }
    if (error && error.response.config.responseType === "blob") {
      let data = error.response.data;
      let reader = new FileReader();
      reader.readAsText(data);
      reader.onload = (e) => {
        let json = JSON.parse(e.target.result);
        MessageBox.alert(json.msg, "系统提示", {
          confirmButtonText: "确定",
          type: "warning",
          customClass: "round-msg-box",
          callback: () => {},
        });
      };
    } else {
      //noMsgCode为数组格式，异常码数组,为-1是表示所有异常状态的处理都自定义
      let noMsgCode = error.response.config.noMsgCode
        ? error.response.config.noMsgCode
        : [];
      if (
        noMsgCode.length > 0 &&
        (noMsgCode.includes(code) || noMsgCode.includes(-1))
      ) {
        return Promise.reject(error.response);
      } else {
        if (code === 401) {
          resetMessageBox("confirm", msg ? msg : "用户暂无访问权限", "系统提示")
            .then(() => {
              auth.goLogin();
            })
            .catch(() => {});
        } else if (code === 400) {
          resetMessageBox("alert", msg, "系统提示")
            .then(() => {})
            .catch(() => {});
        } else if (code === 403) {
          resetMessageBox("alert", msg ? msg : "暂无权限", "系统提示")
            .then(() => {})
            .catch(() => {});
        } else if (code === 500) {
          resetMessageBox("alert", msg ? msg : "系统异常", "系统提示")
            .then(() => {})
            .catch(() => {});
        } else if (code === 503) {
          resetMessage({ type: "error", message: "服务异常" });
        } else if (code === 404) {
          resetMessage({ type: "error", message: "Not Found" });
        } else {
          resetMessage({ type: "error", message: msg });
        }
      }
    }
    return Promise.reject(error.response.data);
  }
);

export default service;
